
  /* =========================================================
     PEETALYA — self-contained sticky header
     Makes the header stick and toggles `.peetalya-sticky-active`
     on `.header-wrapper` (the element with the visible background,
     so the frosted blur actually shows). Works whether or not
     Dawn's "Sticky header" setting is enabled.
     ========================================================= */
  (function () {
    var wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;

    /* Force stickiness on the outermost header element so it doesn't
       depend on the theme's Sticky-header setting. */
    var stickyEl = wrapper.closest('sticky-header') || wrapper;
    stickyEl.style.position = 'sticky';
    stickyEl.style.top = '0';
    stickyEl.style.zIndex = '50';

    var threshold = 40;
    var ticking = false;

    function update() {
      wrapper.classList.toggle('peetalya-sticky-active', window.scrollY > threshold);
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    update();
  })();
